import { useResizeDetector } from 'react-resize-detector';

const Light = ({ fillTailwindClassName = 'fill-green-300' }) => {
  const { width = 0, height = 0, ref } = useResizeDetector();

  const size = Math.min(width, height); // get the smaller dimension to make the circle fit the box

  return (
    <div ref={ref} className="w-full h-full">
      {size > 0 ? (
        <svg viewBox={`0 0 ${size} ${size}`} width={size} height={size} className="mx-auto">
          <circle cx={size / 2} cy={size / 2} r={size / 2} className={fillTailwindClassName} />
        </svg>
      ) : null}
    </div>
  );
};

export const TrafficLight = ({ title = '', fill = 'fill-green-300', tooltip = '' }) => {
  return (
    <div className="h-full w-full" style={{ overflow: 'auto' }}>
      <div className="text-xs text-center">{title}</div>
      <div className="flex justify-center items-center h-full" title={tooltip}>
        <Light fillTailwindClassName={fill} />
      </div>
    </div>
  );
};
